export default __webpack_public_path__ + "static/media/gallery_03.7d04a361.jpg";